import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountArrows = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 5.8,
			cy: 16.32,
			r: 2.39
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M1.5,23.48V23a4.3,4.3,0,0,1,4.3-4.3h0A4.3,4.3,0,0,1,10.09,23v.48"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 18.2,
			cy: 3.91,
			r: 2.39
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M13.91,11.07v-.48A4.29,4.29,0,0,1,18.2,6.3h0a4.29,4.29,0,0,1,4.3,4.29v.48"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "15.7 15.72 18.68 12.75 21.66 15.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M18.68,13v2.86A5.73,5.73,0,0,1,13,21.57h0"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "8.3 8.32 5.32 11.3 2.34 8.32"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M5.32,11.07V8.2a5.72,5.72,0,0,1,5.73-5.72h0"
		})
	]
});
const ForwardRef = forwardRef(SvgAccountArrows);
export default ForwardRef;
